import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { GraduationCap } from "@phosphor-icons/react";
import { useAuth, apiError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/app");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const demo = (em, pw) => {
    setEmail(em);
    setPassword(pw);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background grid-pattern px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 shadow-xl">
        <Link to="/" className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <GraduationCap size={24} weight="fill" />
          </div>
          <span className="font-display text-lg font-extrabold tracking-tight text-primary">ECL Abidjan</span>
        </Link>
        <h1 className="font-display text-2xl font-extrabold tracking-tight">Connexion</h1>
        <p className="mt-1 text-sm text-muted-foreground">Accédez à votre espace pédagogique.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="mt-1" />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="mt-1" />
          </div>
          <Button type="submit" className="w-full bg-primary hover:bg-primary/90" disabled={loading} data-testid="login-submit">
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>

        <div className="mt-6 rounded-lg bg-secondary p-3 text-xs">
          <p className="mb-2 font-semibold text-muted-foreground">Comptes de démonstration :</p>
          <div className="flex flex-wrap gap-2">
            <button onClick={() => demo("admin@ecl-abidjan.ci", "Admin2025!")} className="rounded bg-primary px-2 py-1 font-medium text-primary-foreground" data-testid="demo-admin">Admin</button>
            <button onClick={() => demo("prof@ecl-abidjan.ci", "Prof2025!")} className="rounded bg-primary px-2 py-1 font-medium text-primary-foreground" data-testid="demo-prof">Professeur</button>
            <button onClick={() => demo("etudiant@ecl-abidjan.ci", "Etudiant2025!")} className="rounded bg-primary px-2 py-1 font-medium text-primary-foreground" data-testid="demo-etudiant">Étudiant</button>
          </div>
        </div>

        <p className="mt-6 text-center text-sm text-muted-foreground">
          Les comptes sont créés par l'administration. Contactez votre administrateur.
        </p>
      </div>
    </div>
  );
}
